export enum DataSchemaDisplayComponentMode {
  Edit = 'edit',
  GenerateCRUDPages = 'generateCRUDPages'
}
